/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Schoolinformation_Jahrgangsstufe1Inputs */

const de__field_schoolinformation_jahrgangsstufe1 = /** @type {(inputs: _Field_Schoolinformation_Jahrgangsstufe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahrgangsstufe`)
};

/**

* @param {_Field_Schoolinformation_Jahrgangsstufe1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_schoolinformation_jahrgangsstufe1 = /** @type {((inputs?: _Field_Schoolinformation_Jahrgangsstufe1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Schoolinformation_Jahrgangsstufe1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_schoolinformation_jahrgangsstufe1(inputs)
});
export { _field_schoolinformation_jahrgangsstufe1 as "_field_schoolInformation_jahrgangsstufe" }